module.exports = __webpack_public_path__ + "img/margarita_1.800dd363.jpg";